import type { IconProps } from './IconProps';

export const ArrowDownIcon = (props: IconProps) => (
  <svg
    fill="none"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      d="M8.23529 2C8.23529 2.94118 8.23529 13.2941 8.23529 13.2941M8.23529 13.2941L12.4706 9.05882M8.23529 13.2941L4 9.05882"
      stroke="currentColor"
      strokeWidth="1.88235"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
